import RayID from "./lib/rayid.js";

export default RayID;
